/*eslint-disable */
var $ = window.jQuery = require('jquery');

import Router from 'vue-router'
import Vue from 'vue'
import store from './store/store'
import toast from './services/toast';

Vue.use(Router)
const router = new Router({
  //  const router {
  mode: 'history',
  canReuse: false,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [{
      path: '*',
      redirectTo: '/'
    },
    {
      path: '/',
      name: 'HomeLandingMain',
      // component: () => import( /* webpackChunkName: "HomeLandingMain" */ './view/home-landing-main-page/index.vue'),
      component: () => import( /* webpackChunkName: "HomeLandingMain" */ './view/public/landing/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap'
        next();
      }
    },
    {
      path: '/login/',
      name: 'loginMainPage',
      component: () => import( /* webpackChunkName: "loginMainPage" */ './view/login-main-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Login'
        next();
      }
    },
    {
      path: '/lbil/',
      component: () => import( /* webpackChunkName: "lbilHome" */ './view/lbil/main-dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
      children: [{
          path: '/',
          redirect: {
            name: 'lbilDashboard'
          }
        },
        {
          path: '/lbil/dashboard/',
          name: 'lbilDashboard',
          component: () => import( /* webpackChunkName: "lbilDashboard" */ './view/lbil/lbil-dashboard/lbilDashboard.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLBILSUserInfoApiFun')
            document.title = 'Lymphomap - LBIL Dashboard'
            next();
          }
        },
        {
          path: '/lbil/admin/',
          name: 'lbilAdminList',
          component: () => import( /* webpackChunkName: "lbilAdminList" */ './view/lbil-admin/consulting-doctors-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getConsultDoctorRequestListFunc')
            store.dispatch('getConsultDoctorRequestPublicListFunc')
            document.title = 'Lymphomap - LBIL Admin'
            next();
          }
        },
        {
          path: '/lbil/admin/filters/',
          name: 'lbilAdminFilters',
          component: () => import( /* webpackChunkName: "lbilAdminFilters" */ './view/lbil-admin/members-filters-categories/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLbilMemberMainFilterAction')
            document.title = 'Lymphomap - LBIL Filters'
            next();
          }
        },
        {
          path: '/lbil/admin/ngos/',
          name: 'lbilAdminNgoList',
          component: () => import( /* webpackChunkName: "lbilAdminNgoList" */ './view/lbil-admin/ngo-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLbilNgoListFunc')
            store.dispatch('getLbilPublicNgoListFunc')
            document.title = 'Lymphomap - LBIL Admin NGOS'
            next();
          }
        },
        {
          path: '/lbil/admin/support-groups/',
          name: 'lbilAdminListSGList',
          component: () => import( /* webpackChunkName: "lbilAdminListSGList" */ './view/lbil-admin/sg-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLbilSGListFunc')
            store.dispatch('getLbilPublicSGListFunc')
            document.title = 'Lymphomap - LBIL Admin Support Groups'
            next();
          }
        },
        {
          path: '/lbil/admin/users/',
          name: 'lbilAdminUsersList',
          component: () => import( /* webpackChunkName: "lbilAdminUsersList" */ './view/lbil-admin/lbil-users-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLbilUsersListFunc')
            document.title = 'Lymphomap - LBIL Admin Users'
            next();
          }
        },
        {
          path: '/lbil/admin/support-chat/',
          name: 'lbilSupportChat',
          component: () => import( /* webpackChunkName: "lbilSupportChat" */ './view/lbil-admin/help-support-chat-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getLbilChatUserListAction')
            document.title = 'LBIL - Support Chat'
            next();
          }
        },
      ],
    },
    {
      path: '/dashboard/',
      component: () => import( /* webpackChunkName: "Dashboard" */ './view/dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        // store.dispatch('getAcUserDetailsFun')
        next();
      },
      children: [{
          path: '/',
          redirect: {
            name: 'DashboardMain'
          }
        },
        {
          path: '/home/',
          name: 'DashboardMain',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/home-dashboard/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getNuAcUpdatesListFun')
            // store.dispatch('getAcUserDetailsFun')
            store.dispatch('getPublicBlogListAction')
            store.dispatch('getBlogListAction')
            store.dispatch('getAboutDetailsOfProfileFun')
            document.title = 'Lymphomap - Home'
            next();
          }
        },
        {
          path: '/task/old/',
          name: 'Dashboard',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/lymphomap/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInputAttrListFun')
            document.title = 'Lymphomap - Home'
            next();
          }
        },
        {
          path: '/task/',
          name: 'Task',
          component: () => import( /* webpackChunkName: "Task" */ './view/task-new-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getInputAttrListFun')
            document.title = 'Lymphomap - Task New'
            next();
          }
        },
        {
          path: '/profile/update/',
          name: 'profileUpdate',
          component: () => import( /* webpackChunkName: "profileUpdate" */ './view/profile-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Profile Update'
            next();
          }
        },
        {
          path: '/data-well/',
          name: 'dataWell',
          component: () => import( /* webpackChunkName: "datawell" */ './view/data-well/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAcUserDetailsFun')
            store.dispatch('getDataWellFun')
            document.title = 'Lymphomap - Data Well'
            next();
          }
        },
        {
          path: '/su/organization/',
          name: 'organizationList',
          component: () => import( /* webpackChunkName: "organizationList" */ './view/organizations-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgListFun')
            document.title = 'Lymphomap - User'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/details/',
          name: 'organizationDetails',
          component: () => import( /* webpackChunkName: "organizationDetails" */ './view/organizations-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgDetailsByIdFun', {
              id: to.params.orgId
            })
            document.title = 'Lymphomap - Organization Details'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/make/super/admin/',
          name: 'makeSuperAdmin',
          component: () => import( /* webpackChunkName: "makeSuperAdmin" */ './view/make-super-admin/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Change Admin'
            next();
          }
        },
        {
          path: '/su/organization/:orgId/details/update/',
          name: 'organizationDetailsUpdate',
          component: () => import( /* webpackChunkName: "organizationDetailsUpdate" */ './components/organization-details-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgDetailsByIdFun', {
              id: to.params.orgId
            })
            document.title = 'Lymphomap - Organization Details Update'
            next();
          }
        },
        {
          path: '/su/organization/add/',
          name: 'organizationAdd',
          component: () => import( /* webpackChunkName: "organizationAdd" */ './components/organization-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization Add'
            next();
          }
        },
        {
          path: '/su/organization/:orgUserId/user/add/',
          name: 'organizationUserAdd',
          component: () => import( /* webpackChunkName: "organizationUserAdd" */ './components/organization-user-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization User Add'
            next();
          }
        },
        {
          path: '/su/organization/:userId/user/update/',
          name: 'organizationUserUpdate',
          component: () => import( /* webpackChunkName: "organizationUserUpdate" */ './components/organization-user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUseDetailsByIdFun', {
              id: to.params.userId
            })
            document.title = 'Lymphomap - Organization User Update'
            next();
          }
        },
        {
          path: '/su/organization/user/:userDetailsId/details/',
          name: 'organizationUserDetails',
          component: () => import( /* webpackChunkName: "organizationUserDetails" */ './view/organization-user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUserDetailsByIdFun', {
              id: to.params.userDetailsId
            })
            store.dispatch('getUserTaskListFun', {
              id: to.params.userDetailsId
            })
            document.title = 'Lymphomap - Organization User Details'
            next();
          }
        },
        {
          path: '/su/organization/connection/request/list/:orgReqId/',
          name: 'organizationConnectionRequestList',
          component: () => import( /* webpackChunkName: "organizationConnectionRequestList" */ './view/organization-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('orgConnectionReqListFun', {
              id: to.params.orgReqId
            })
            document.title = 'Lymphomap - Organization Connection List'
            next();
          }
        },
        {
          path: '/su/organization/user/request/list/:userReqId/',
          name: 'organizationUserRequestList',
          component: () => import( /* webpackChunkName: "organizationUserRequestList" */ './view/user-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('userChatRequestListFun', {
              id: to.params.userReqId
            })
            document.title = 'Lymphomap - Organization User Request List'
            next();
          }
        },
        {
          path: '/su/account/updates/list/',
          name: 'acSuUpdatesList',
          component: () => import( /* webpackChunkName: "acSuUpdatesList" */ './view/su-account-updates/account-su-updates-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSuAcUpdatesListFun')
            document.title = 'Lymphomap - Account Update List'
            next();
          }
        },
        {
          path: '/su/account/updates/create/',
          name: 'acSuUpdatesCreate',
          component: () => import( /* webpackChunkName: "acSuUpdatesCreate" */ './view/su-account-updates/account-su-updates-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Account Update Create'
            next();
          }
        },
        {
          path: '/su/account/updates/:updatesId/update/',
          name: 'acSuUpdatesUpdate',
          component: () => import( /* webpackChunkName: "acSuUpdatesUpdate" */ './view/su-account-updates/account-su-updates-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSuAcUpdatesListByIdFun', {
              id: to.params.updatesId
            })
            document.title = 'Lymphomap - Account Update Create'
            next();
          }
        },
        {
          path: '/sa/organization/',
          name: 'saOrganizationList',
          component: () => import( /* webpackChunkName: "saOrganizationList" */ './view/super-admin/sa-organization-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgListFun')
            document.title = 'Lymphomap - Admin'
            next();
          }
        },
        {
          path: '/sa/organization/update/',
          name: 'saOrganizationUpdate',
          component: () => import( /* webpackChunkName: "saOrganizationUpdate" */ './view/super-admin/sa-organization-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgListFun')
            document.title = 'Lymphomap - Organization Update'
            next();
          }
        },
        {
          path: '/sa/organization/user/create/',
          name: 'saOrganizationUserCreate',
          component: () => import( /* webpackChunkName: "saOrganizationUserCreate" */ './view/super-admin/sa-organization-user-create/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Organization User Create'
            next();
          }
        },
        {
          path: '/sa/organization/user/:saUserId/update/',
          name: 'saOrganizationUserUpdate',
          component: () => import( /* webpackChunkName: "saOrganizationUserUpdate" */ './view/super-admin/sa-organization-user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgUseDetailsByIdFun', {
              id: to.params.saUserId
            })
            document.title = 'Lymphomap - Organization User Update'
            next();
          }
        },
        {
          path: '/sa/organization/user/:saUserDetailsId/details/',
          name: 'saOrganizationUserDetails',
          component: () => import( /* webpackChunkName: "saOrganizationUserDetails" */ './view/super-admin/sa-organization-user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSaOrgUseDetailsByIdFun', {
              id: to.params.saUserDetailsId
            })
            store.dispatch('getSaUserTaskListFun', {
              id: to.params.saUserDetailsId
            })
            document.title = 'Lymphomap - Organization User Details'
            next();
          }
        },
        {
          path: '/support/chat/',
          name: 'supportWorkspace',
          component: () => import( /* webpackChunkName: "teamWorkspace" */ './view/private/support-chat-workspace/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('ticketChatListAction');
            document.title = 'Lymphomap - Support Chat';
            next();
          }
        },
        {
          path: '/workspace/',
          name: 'teamWorkspace',
          component: () => import( /* webpackChunkName: "teamWorkspace" */ './view/private/workspace/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllLeftChatListDetailsFun');
            store.dispatch('getSchedulerListAction');
            next();
            document.title = 'Lymphomap - workspace'
          }
        },
        {
          path: '/chat/user/block/list/',
          name: 'userBlockList',
          component: () => import( /* webpackChunkName: "userBlockList" */ './components/blocked-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlockUserFun')
            document.title = 'Lymphomap - User Block List'
            next();
          }
        },
        {
          path: '/organization/',
          name: 'normalOrganizationList',
          component: () => import( /* webpackChunkName: "normalOrganizationList" */ './view/noraml-user-org-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('normalUserOrgListFun')
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Organization'
            next();
          }
        },
        {
          path: '/organization/:OrgByUserId/user/list/',
          name: 'OrganizationByUserList',
          component: () => import( /* webpackChunkName: "OrganizationByUserList" */ './view/user-list-by-organization/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserListByOrgFun', {
              id: to.params.OrgByUserId
            })
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Organization User List'
            next();
          }
        },
        {
          path: '/members/',
          name: 'membersAllUsers',
          component: () => import( /* webpackChunkName: "membersAllUsers" */ './view/member-all-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberFilterCountFun')
            store.dispatch('memberAllUsersListFun')
            document.title = 'Lymphomap - Member Users'
            next();
          }
        },
        {
          path: '/members/connected/users/',
          name: 'membersConnectedUsers',
          component: () => import( /* webpackChunkName: "membersConnectedUsers" */ './view/member-connected-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('memberConnectedUsersListFun')
            store.dispatch('getConnectedMemberCountFun')
            document.title = 'Lymphomap - Member Users'
            next();
          }
        },
        {
          path: '/video/conference/',
          name: 'videoCreateMeeting',
          component: () => import( /* webpackChunkName: "create-meeting" */ './view/video-meeting-create/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAcUserDetailsFun')
            document.title = 'Lymphomap - Video Conference',
              next();
          }
        },
        {
          path: '/meeting/',
          name: 'videoCreateMeetingList',
          component: () => import( /* webpackChunkName: "videoCreateMeetingList" */ './view/create-meeting-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getMeetingAllListFun')
            document.title = 'Lymphomap - Video Meeting',
              next();
          }
        },
        {
          path: '/meeting/deleted/list/',
          name: 'deletedMeetingList',
          component: () => import( /* webpackChunkName: "deletedMeetingList" */ './view/deleted-meetings-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Deleted Meeting',
              next();
          }
        },
        {
          path: '/admin/notifications/',
          name: 'globalNotification',
          component: () => import( /* webpackChunkName: "globalNotification" */ './view/global-notification-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getGlobalNotificationMethod', {flag:'False'})
            document.title = 'Lymphomap - Notifications'
            next();
          }
        },
        {
          path: '/video/user/left/room/',
          name: 'UserLeftRoom',
          component: () => import( /* webpackChunkName: "UserLeftRoom" */ './view/user-left-room/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video User Left Room',
              next();
          }
        },
        {
          path: '/members/users/details/:userDetailsId/',
          name: 'memberUserDetails',
          component: () => import( /* webpackChunkName: "memberUserDetails" */ './view/user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAboutDetailsOfMemberUserFun', {
              id: to.params.userDetailsId
            })
            store.dispatch('getUserOnlineTimeCountApiUrlFun', {
              id: to.params.userDetailsId
            })
            document.title = 'Lymphomap - User Details'
            next();
          }
        },
        {
          path: '/request/list/',
          name: 'saChatRequestList',
          component: () => import( /* webpackChunkName: "saChatRequestList" */ './view/super-admin/chat-request-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('chatConnectionRequestListFun')
            document.title = 'Lymphomap - User Request'
            next();
          }
        },
        {
          path: '/admin/',
          name: 'usersList',
          component: () => import( /* webpackChunkName: "usersList" */ './view/users/all-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Admin'
            next();
          }
        },
        {
          path: '/admin/event/',
          name: 'adminEvent',
          component: () => import( /* webpackChunkName: "adminEvent" */ './view/events/events-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getEventListAction')
            document.title = 'Lymphomap - Admin Event'
            next();
          }
        },
        {
          path: '/admin/event/add/',
          name: 'adminEventAdd',
          component: () => import( /* webpackChunkName: "adminEventAdd" */ './view/events/create-event-data-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Admin Event Add'
            next();
          }
        },
        {
          path: '/admin/event/update/:eventId',
          name: 'adminEventUpdate',
          component: () => import( /* webpackChunkName: "adminEventUpdate" */ './view/events/update-event-data-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Admin Event Update'
            next();
          }
        },
        {
          path: '/admin/event/galleries/:eventId',
          name: 'adminEventGalleries',
          component: () => import( /* webpackChunkName: "adminEventGalleries" */ './view/events/event-gallery-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getEventListAction')
            document.title = 'Lymphomap - Admin Event'
            next();
          }
        },
        {
          path: '/admin/user/guest/',
          name: 'guestUsersList',
          component: () => import( /* webpackChunkName: "guestUsersList" */ './view/guest-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getGuestUserListFun')
            document.title = 'Lymphomap - Guest Users'
            next();
          }
        },
        {
          path: '/admin/user/add/',
          name: 'addUser',
          component: () => import( /* webpackChunkName: "addUser" */ './view/users/user-add/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - User Add'
            next();
          }
        },
        {
          path: '/admin/user/log/',
          name: 'guestUsersSpendTimeLog',
          component: () => import( /* webpackChunkName: "guestUsersSpendTimeLog" */ './view/user-spend-time-log/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllUserOnlineTimeCountApiUrlFun')
            document.title = 'Lymphomap - Users Time Log'
            next();
          }
        },
        {
          path: '/admin/llist-users/',
          name: 'adminRListUsers',
          component: () => import( /* webpackChunkName: "adminRListUsers" */ './view/admin/rlist-users/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getRListUsersFun')
            document.title = 'Lymphomap - L List Users'
            next();
          }
        },
        {
          path: '/admin/user/:updateUserID/update/',
          name: 'updateUser',
          component: () => import( /* webpackChunkName: "updateUser" */ './view/users/user-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUseDetailsByIdFun', {
              id: to.params.updateUserID
            })
            document.title = 'Lymphomap - User Update'
            next();
          }
        },
        {
          path: '/admin/user/:UserID/connection/list/',
          name: 'userConnectionList',
          component: () => import( /* webpackChunkName: "userConnectionList" */ './view/users/user-connection-request-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('userChatRequestListFun', {
              id: to.params.UserID
            })
            document.title = 'Lymphomap - User Connection'
            next();
          }
        },
        {
          path: '/admin/user/:UserID/activity/details/',
          name: 'userActivityDetails',
          component: () => import( /* webpackChunkName: "userActivityDetails" */ './view/users/user-activity-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getActivityLogOfuserByIdFun', {
              id: to.params.UserID
            });
            document.title = 'Lymphomap - User Activity Details';
            next();
          }
        },
        {
          path: '/admin/email&sms/compose/',
          name: 'globalMessage',
          component: () => import( /* webpackChunkName: "globalMessage" */ './view/global-message-user/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('isConditionalListOfAllUsersFun');
            document.title = 'Lymphomap - Email & SMS Compose';
            next();
          }
        },
        {
          path: '/admin/sent/email&sms/list/',
          name: 'adminSentEmailSms',
          component: () => import( /* webpackChunkName: "adminSentEmailSms" */ './view/sent-email-sms-page/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Email & SMS List';
            next();
          }
        },
        {
          path: '/admin/webinar/',
          name: 'adminWebinarList',
          component: () => import( /* webpackChunkName: "adminWebinarList" */ './view/admin/webinar-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getWebinarAllListOfAdminFun')
            document.title = 'Lymphomap - Admin Webinar',
              next();
          }
        },
        {
          path: '/admin/filters/',
          name: 'memberFiltersCat',
          component: () => import( /* webpackChunkName: "memberFiltersCat" */ './view/members/members-filters-categories/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberMainFilterAction')
            document.title = 'Lymphomap - Filters'
            next();
          }
        },
        {
          path: '/admin/filters/:filterId/categories/',
          name: 'memberFiltersProCat',
          component: () => import( /* webpackChunkName: "memberFiltersCat" */ './view/members/members-professional-categories/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberMainFilterAction')
            store.dispatch('getMemberMainFilterDetailsByIdAction', {
              id: to.params.filterId
            })
            document.title = 'Lymphomap - Filter Categories'
            next();
          }
        },
        {
          path: '/admin/unsubscribed/user/list/',
          name: 'unsubscribedUsersList',
          component: () => import( /* webpackChunkName: "unsubscribedUsersList" */ './view/users/unsubscribed-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('geUnsubscribedUserListAction')
            document.title = 'Lymphomap - Unsubscribed Users List'
            next();
          }
        },
        {
          path: '/admin/presentation/file/upload/',
          name: 'presentationFileUpload',
          component: () => import( /* webpackChunkName: "presentationFileUpload" */ './view/admin/presentation-file-list-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getPresentationListAction')
            document.title = 'Lymphomap - Presentation File Upload'
            next();
          }
        },
        {
          path: '/video/call/one-to-one-peer/',
          name: 'videoCallOneToOnePeer',
          // component: () => import( /* webpackChunkName: "videoCallOneToOnePeer" */ './view/one-to-one-direct-call-with-red5pro/index.vue'),
          component: () => import( /* webpackChunkName: "videoCallOneToOnePeer" */ './view/jisti-video-confreness-for-one-to-one/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('checkRoomValidIdFun', {
              room_id: to.hash
            }).then((res) => {})
            store.dispatch('getAcUserDetailsFun').then((res) => {
              next();
            })
            document.title = 'Lymphomap - Video Conference'
          }
        },
        {
          path: '/video/one-to-one-peer/left/room/',
          name: 'OneToOnePeerLeftRoom',
          component: () => import( /* webpackChunkName: "OneToOnePeerLeftRoom" */ './view/direct-call-from-user-left/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video User Left Room',
              next();
          }
        },
        {
          path: '/conference/',
          name: 'red5',
          // component: () => import( /* webpackChunkName: "red5" */ './view/red5-pro/index.vue'),
          component: () => import( /* webpackChunkName: "red5" */ './view/jitsi-for-meetings-conf/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video Conference';
            next();
            // store.dispatch('confrenceUserCountFun', {
            //   room_id: to.hash
            // }).then((res) => {
            //   store.dispatch('getAcUserDetailsFun')
            //   document.title = 'Lymphomap - Video Conference';
            //   if (res.data.data < 20) {
            //     next();
            //   } else {
            //     toast.error('Room Full');
            //     router.push('/webinar/')
            //   }
            // }).catch((err) => {
            //   router.push('/webinar/')
            // })
            // next();
          }
        },
        {
          path: '/conference/user/left/room/',
          name: 'UserLeftRoomInConference',
          component: () => import( /* webpackChunkName: "UserLeftRoomInConference" */ './view/conference-room-in-user-left/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Conference User Left Room',
              next();
          }
        },
        {
          path: '/webinar/',
          name: 'webinar',
          component: () => import( /* webpackChunkName: "webinar" */ './view/webinar-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getWebinarAllListFun');
            store.dispatch('isConditionalListOfAllUsersFun');
            document.title = 'Lymphomap - Webinar';
            next();
          }
        },
        {
          path: '/mobile/blog/',
          name: 'mobileViewBlog',
          component: () => import( /* webpackChunkName: "mobileViewBlog" */ './view/mobileView/blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getPublicBlogListAction');
            store.dispatch('getBlogListAction');
            document.title = 'Lymphomap - Blog';
            next();
          }
        },
        {
          path: '/blog/create/',
          name: 'blogCreate',
          component: () => import( /* webpackChunkName: "blogCreate" */ './view/blogs/create-blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('isConditionalListOfAllUsersFun')
            document.title = 'Lymphomap - Blog Create',
              next();
          }
        },
        {
          path: '/blog/update/:updateId/',
          name: 'blogUpdate',
          component: () => import( /* webpackChunkName: "blogUpdate" */ './view/blogs/update-blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('isConditionalListOfAllUsersFun')
            document.title = 'Lymphomap - Blog Update',
              next();
          }
        }, {
          path: '/blog/detail/:blogId',
          name: 'blogDetail',
          component: () => import( /* webpackChunkName: "blogDetail" */ './view/blogs/blog-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlogDetailsByIdAction', {
              id: to.params.blogId
            })
            store.dispatch('getBlogVoteInfoAction', {
              id: to.params.blogId
            })
            store.dispatch('getSuggestionBlogListAction')
            document.title = 'Lymphomap - Blog Detail',
              next();
          }
        }, {
          path: '/private/blog/detail/:blogId',
          name: 'privateBlogDetail',
          component: () => import( /* webpackChunkName: "privateBlogDetail" */ './view/blogs/private-blog-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlogDetailsByIdAction', {
              id: to.params.blogId
            })
            store.dispatch('getBlogVoteInfoAction', {
              id: to.params.blogId
            })
            store.dispatch('getSuggestionBlogListAction')
            document.title = 'Lymphomap - Blog Detail',
              next();
          }
        },
        {
          path: '/data/',
          name: 'algoData',
          component: () => import( /* webpackChunkName: "algoData" */ './view/algo-data/algo-dashboard/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            // store.dispatch('getAllPubAlgoDataListAction')
            // store.dispatch('getAlgoDataListAction')
            document.title = 'Lymphomap - Data',
              next();
          }
        },
        {
          path: '/all/users/data/',
          name: 'algoAllUserData',
          component: () => import( /* webpackChunkName: "algoAllUserData" */ './view/algo-data/algo-all-user-data/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllUserAlgoDataListAction')
            document.title = 'Lymphomap - Data',
              next();
          }
        },
        {
          path: '/ai/',
          name: 'AiDashboard',
          component: () => import( /* webpackChunkName: "AiDashboard" */ './view/ai-dashboard/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - AI Dashboard'
            next();
          }
        },
        {
          path: '/ai/models/create/',
          name: 'AiModelsCreated',
          component: () => import( /* webpackChunkName: "AiModelsCreated" */ './view/ai-dashboard/create-new-models/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getDiseaseListForAiDashFun');
            store.dispatch('getMostUsedTrainModelForAiDashFun');
            document.title = 'Lymphomap - AI Models Create';
            next();
          }
        },
        {
          path: '/ai/public/models/:pubModelsId',
          name: 'publicModelsMake',
          component: () => import( /* webpackChunkName: "publicModelsMake" */ './view/ai-dashboard/make-public-models/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getMostUsedTrainModelForAiDashFun');
            store.dispatch('getModelDetailsByIDForAIFun', {
              id: to.params.pubModelsId
            });
            document.title = 'Lymphomap - AI Public Models';
            next();
          }
        },
        {
          path: '/ai/model/predication/:useModelsId',
          name: 'useModelsData',
          component: () => import( /* webpackChunkName: "useModelsData" */ './view/ai-dashboard/model-predication/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getModelDetailsByIDForAIFun', {
              id: to.params.useModelsId
            });
            document.title = 'Lymphomap - AI Use Models';
            next();
          }
        },
        {
          path: '/ai/landing/',
          name: 'aiLandingPage',
          component: () => import( /* webpackChunkName: "aiLandingPage" */ './view/ai-dashboard/ai-landing-page/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - AI Landing',
              next();
          }
        },
        {
          path: '/staff/',
          name: 'employeeList',
          component: () => import( /* webpackChunkName: "employeeList" */ './view/employee/employee-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('geEmployeeListFun')
            document.title = 'Lymphomap - Staff'
            next();
          }
        },
        {
          path: '/employee/add/',
          name: 'addEmployeeForm',
          component: () => import( /* webpackChunkName: "addEmployeeForm" */ './view/employee/add-employee-form/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Add'
            next();
          }
        },
        {
          path: '/staff/employee/update/:employeeId',
          name: 'updateEmployeeForm',
          component: () => import( /* webpackChunkName: "updateEmployeeForm" */ './view/employee/update-employee-form/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getOrgUseDetailsByIdFun', {
              id: to.params.employeeId
            })
            document.title = 'Lymphomap - Employee Update'
            next();
          }
        },
        {
          path: '/employee/leave/list/',
          name: 'employeeLeaveList',
          component: () => import( /* webpackChunkName: "employeeLeaveList" */ './view/employee/leave-list-of-manager/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAdminOfEmployeeLeaveListFun')
            document.title = 'Lymphomap - Employee Leave'
            next();
          }
        },
        {
          path: '/leave/',
          name: 'LeaveList',
          component: () => import( /* webpackChunkName: "LeaveList" */ './view/employee/leave-list-of-emplooyee/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('geEmployeeLeaveListFun')
            document.title = 'Lymphomap - Leave'
            next();
          }
        },
        {
          path: '/leave/request/',
          name: 'employeeLeaveRequest',
          component: () => import( /* webpackChunkName: "employeeLeaveRequest" */ './view/employee/employee-leave-portal/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Leave Request'
            next();
          }
        },
        {
          path: '/employee/task/',
          name: 'employeeTaskList',
          component: () => import( /* webpackChunkName: "employeeTaskList" */ './view/employee/emplooye-task-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getEmployeeTaskListFun')
            document.title = 'Lymphomap - Employee Task'
            next();
          }
        },
        {
          path: '/employee/task/add/',
          name: 'employeeTaskAdd',
          component: () => import( /* webpackChunkName: "employeeTaskAdd" */ './view/employee/emplooye-task-add/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getEmployeeTaskListFun')
            document.title = 'Lymphomap - Employee Task'
            next();
          }
        },
        {
          path: '/employee/task/update/:updateID',
          name: 'employeeTaskUpdate',
          component: () => import( /* webpackChunkName: "employeeTaskUpdate" */ './view/employee/emplooye-task-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getEmployeeTaskInfoByIDFun', {
              id: to.params.updateID
            })
            document.title = 'Lymphomap - Employee Task'
            next();
          }
        },
        {
          path: '/staff/employee/interview/candidates-with-qbank/:candidateId',
          name: 'candidateLinkageWqBank',
          component: () => import( /* webpackChunkName: "candidateLinkageWqBank" */ './view/employee/interview/qbank-link-w-cadidates/candidate-linkage-with-qbank-page-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Interview Candidates'
            next();
          }
        },
        {
          path: '/staff/employee/interview/candidates/',
          name: 'employeeInterviewCandidatesList',
          component: () => import( /* webpackChunkName: "employeeInterviewCandidatesList" */ './view/employee/interview/candidate/candidate-list-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInViewerCandidateListAction')
            document.title = 'Lymphomap - Employee Interview Candidates'
            next();
          }
        },
        {
          path: '/staff/employee/interview/candidate/add/',
          name: 'employeeInterviewCandidatesAdd',
          component: () => import( /* webpackChunkName: "employeeInterviewCandidatesAdd" */ './view/employee/interview/candidate/create-candidate-form/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Interview Candidates Add'
            next();
          }
        },
        {
          path: '/staff/employee/interview/candidate/update/:candidateId',
          name: 'employeeInterviewCandidatesUpdate',
          component: () => import( /* webpackChunkName: "employeeInterviewCandidatesUpdate" */ './view/employee/interview/candidate/update-candidate-form/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Interview Candidates Update'
            next();
          }
        },
        {
          path: '/staff/employee/interview/',
          name: 'employeeInterviewList',
          component: () => import( /* webpackChunkName: "employeeInterPageView" */ './view/employee/interview/interview-page-view/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Interview'
            next();
          }
        },
        {
          path: '/staff/employee/interview/add/',
          name: 'employeeInterviewAdd',
          component: () => import( /* webpackChunkName: "employeeInterviewAdd" */ './view/employee/interview/interview-add/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Employee Interview Add'
            next();
          }
        },
        {
          path: '/staff/employee/interview/promote/:promoteID',
          name: 'employeeInterviewPromote',
          component: () => import( /* webpackChunkName: "employeeInterviewPromote" */ './view/employee/interview/interview-promote/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInterviewerListFun')
            store.dispatch('getInterviewInfoByIDFun', {
              id: to.params.promoteID
            })
            document.title = 'Lymphomap - Employee Interview Promote'
            next();
          }
        },
        {
          path: '/staff/employee/interview/reschedule/:rescheduledInterviewID',
          name: 'employeeInterviewRescheduled',
          component: () => import( /* webpackChunkName: "employeeInterviewRescheduled" */ './view/employee/interview/interview-reschedule/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInterviewInfoByIDFun', {
              id: to.params.rescheduledInterviewID
            })
            document.title = 'Lymphomap - Employee Interview Reschedule'
            next();
          }
        },
        {
          path: '/staff/employee/interview/update/:updateID',
          name: 'employeeInterviewUpdate',
          component: () => import( /* webpackChunkName: "employeeInterviewUpdate" */ './view/employee/interview/interview-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getInterviewInfoByIDFun', {
              id: to.params.updateID
            })
            document.title = 'Lymphomap - Employee Interview Update'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/',
          name: 'inviewQbankList',
          component: () => import( /* webpackChunkName: "inviewQbankList" */ './view/employee/interview/Qbank/q-bank-list-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQBankInfoAction')
            document.title = 'Lymphomap - Interview Q Bank'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/add/',
          name: 'inviewQbankAdd',
          component: () => import( /* webpackChunkName: "inviewQbankAdd" */ './view/employee/interview/Qbank/q-bank-creation-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Interview Q Bank Add'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/update/:qbankId',
          name: 'inviewQbankUpdate',
          component: () => import( /* webpackChunkName: "inviewQbankUpdate" */ './view/employee/interview/Qbank/q-bank-update-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Interview Q Bank Update'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/question-answer/list/:qbankId',
          name: 'inviewQbankQansList',
          component: () => import( /* webpackChunkName: "inviewQbankQansList" */ './view/employee/interview/qAns/q-ans-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQAnsListWithOptionAction', {id: to.params.qbankId})
            document.title = 'Lymphomap - Interview Q Bank'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/question-answer/list/add/:qbankId',
          name: 'inviewQbankQansAdd',
          component: () => import( /* webpackChunkName: "inviewQbankQansAdd" */ './view/employee/interview/qAns/q-ans-add-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Interview Q Bank'
            next();
          }
        },
        {
          path: '/staff/employee/interview/qbank/question-answer/list/update/:qbankId/:QueAnsId',
          name: 'inviewQbankQansUpdate',
          component: () => import( /* webpackChunkName: "inviewQbankQansUpdate" */ './view/employee/interview/qAns/q-ans-update-screen/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Interview Q Bank'
            next();
          }
        },
        {
          path: '/vista/',
          name: 'vistaConference',
          component: () => import( /* webpackChunkName: "vistaConference" */ './view/vista-conference/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('vistaConferenceListFun')
            document.title = 'Lymphomap - Vista',
              next();
          }
        },
        {
          path: '/vista/users/',
          name: 'vistaUsers',
          component: () => import( /* webpackChunkName: "vistaUsers" */ './view/vista-conference/user-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('vistaConferenceUserListFun')
            document.title = 'Lymphomap - Vista Users',
              next();
          }
        },
        {
          path: '/subscription/product/',
          name: 'subscriptionProduct',
          component: () => import( /* webpackChunkName: "subscriptionProduct" */ './view/subscription-plan/product-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getSubscriptionProductListFunc')
            document.title = 'Lymphomap - Subscription Product',
              next();
          }
        },
        {
          path: '/subscription/plan/',
          name: 'subscriptionPlan',
          component: () => import( /* webpackChunkName: "subscriptionPlan" */ './view/subscription-plan/plan-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getSubscriptionPlanListFunc')
            document.title = 'Lymphomap - Subscription Plan',
              next();
          }
        },
        {
          path: '/admin/demo/request/list/all/',
          name: 'demoRequestListAll',
          component: () => import( /* webpackChunkName: "demoRequestListAll" */ './view/demo-request-all-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllDemoRequestListAction')
            document.title = 'Lymphomap - Demo For Request',
              next();
          }
        },
        {
          path: '/admin/completed/demo/request/list/all/',
          name: 'completedDemoRequestListAll',
          component: () => import( /* webpackChunkName: "completedDemoRequestListAll" */ './view/completed-demo-request-all-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getCompletedAllDemoRequestListAction');
            document.title = 'Lymphomap - Completed Demo For Request';
            next();
          }
        },
        {
          path: '/admin/demo/request/feedbacks/',
          name: 'demoRequestFeedbacks',
          component: () => import( /* webpackChunkName: "demoRequestFeedbacks" */ './view/demo-request-feedback-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllDemoReqFeedbackListAction');
            document.title = 'Lymphomap - Demo Request Feedbacks';
            next();
          }
        },
        {
          path: '/admin/faq/feedbacks/',
          name: 'faqFeedbacks',
          component: () => import( /* webpackChunkName: "faqFeedbacks" */ './view/private/faq-submission-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllFAQFeedbackListAction');
            document.title = 'Lymphomap - FAQ Feedbacks';
            next();
          }
        },
        {
          path: '/admin/bot/tickets/',
          name: 'botTickets',
          component: () => import( /* webpackChunkName: "botTickets" */ './view/private/bot-tickets/index.vue'),
          guest: true,
          props:true,
          beforeEnter: (to, from, next) => {
            store.dispatch('botTicketListAction', {filter : ''});
            document.title = 'Lymphomap - Bot Tickets';
            next();
          }
        },
        {
          path: '/admin/bot/feedbacks/',
          name: 'tukivitaFeedbacks',
          component: () => import( /* webpackChunkName: "tukivitaFeedbacks" */ './view/private/tukivita-feedbacks-list/index.vue'),
          guest: true,
          props:true,
          beforeEnter: (to, from, next) => {
            store.dispatch('tukivitaFeedbacksListAction');
            document.title = 'Lymphomap - Tukivita Feedbacks';
            next();
          }
        },
        {
          path: '/awerack/',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/paperpiles/awerack-root/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getBucketListOfAwerackFun')
            next();
          },
          children: [{
              path: '/awerack/paper/list',
              name: 'paperPiles',
              component: () => import( /* webpackChunkName: "paperPiles" */ './view/paperpiles/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun')
                document.title = 'Lymphomap - AweRack',
                  next();
              }
            },
            {
              path: '/awerack/shared/paper/',
              name: 'awerackSharedPaper',
              component: () => import( /* webpackChunkName: "awerackSharedPaper" */ './view/paperpiles/shared-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getSharedPaperListFun')
                document.title = 'Lymphomap - AweRack Shared Paper',
                  next();
              }
            },
            {
              path: '/awerack/paper/favourites/',
              name: 'favouritePaperList',
              component: () => import( /* webpackChunkName: "favouritePaperList" */ './view/paperpiles/favourite-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getFavouritePaperListFun')
                document.title = 'Lymphomap - Favourite Paper',
                  next();
              }
            },
            {
              path: '/awerack/paper/trash/',
              name: 'trashPaperList',
              component: () => import( /* webpackChunkName: "trashPaperList" */ './view/paperpiles/trash-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getTrashPaperListFun')
                store.dispatch('getTrashFolderListFun')
                document.title = 'Lymphomap - Trash Paper',
                  next();
              }
            },
            {
              path: '/awerack/preference/',
              name: 'paperPilesPreferences',
              component: () => import( /* webpackChunkName: "paperPilesPreferences" */ './view/paperpiles/paper-preferences/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                document.title = 'Lymphomap - AweRack Preference',
                  next();
              }
            },
            {
              path: '/awerack/research-group/',
              name: 'awerackResearchGroup',
              component: () => import( /* webpackChunkName: "awerackResearchGroup" */ './view/paperpiles/research-group-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun');
                store.dispatch('getResearchGroupListFun');
                store.dispatch('isConditionalListOfAllUsersFun');
                document.title = 'Lymphomap - AweRack Research Group';
                next();
              }
            },
            {
              path: '/awerack/research-group/details/:researchGId',
              name: 'awerackResearchGroupDetails',
              component: () => import( /* webpackChunkName: "awerackResearchGroupDetails" */ './view/paperpiles/research-group-detail/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getResearchGroupDetailsByIDFun', {
                  id: to.params.researchGId
                })
                document.title = 'Lymphomap - Research Group Details',
                  next()
              }
            },
            {
              path: '/awerack/bucket/:bucketId',
              name: 'bucketDetails',
              component: () => import( /* webpackChunkName: "bucketDetails" */ './view/paperpiles/bucket-details/index.vue'),
              guest: true,
              props: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getBucketDetailsByIdOfAwerackFun', {
                  id: to.params.bucketId
                })
                document.title = 'Lymphomap - AweRack Bucket',
                  next()
              }
            },
          ]
        },
      ]
    },
    {
      path: '/presentation_1.0/',
      name: 'presentation',
      component: () => import( /* webpackChunkName: "presentation" */ './view/presentation/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Presentation',
          next();
      }
    },
    {
      path: '/public/blog/detail/:pubBlogId',
      name: 'pubBlogDetail',
      component: () => import( /* webpackChunkName: "pubBlogDetail" */ './view/blogs/public-blog-details/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('getPublicBlogDetailsByIdAction', {
          id: to.params.pubBlogId
        })
        store.dispatch('getSuggestionBlogListAction')
        document.title = 'Lymphomap - Blog Detail',
          next();
      }
    },
    {
      path: '/user/agreement/',
      name: 'userAgreement',
      component: () => import( /* webpackChunkName: "userAgreement" */ './view/public/user-agreement/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - User Agreement',
          next();
      }
    },
    {
      path: '/privacy-policy/',
      name: 'privacyPolicy',
      component: () => import( /* webpackChunkName: "privacyPolicy" */ './view/public/privacy-policy/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Privacy Policy',
          next();
      }
    },
    {
      path: '/tracking/unsubscribe/:unsubscribeID',
      name: 'trackingUnsubscribe',
      component: () => import( /* webpackChunkName: "trackingUnsubscribe" */ './view/unsubscribe/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Unsubscribe',
          next();
      }
    },
    {
      path: '/contact-us/',
      name: 'contactUs',
      component: () => import( /* webpackChunkName: "contactUs" */ './view/contact-us/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Contact Us',
          next();
      }
    },
    {
      path: '/about-us/',
      name: 'AboutUsMainPage',
      component: () => import( /* webpackChunkName: "AboutUsMainPage" */ './view/public/about-us-main-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - About Us',
          next();
      }
    },
    {
      path: '/faq/',
      name: 'faqPage',
      component: () => import( /* webpackChunkName: "faqPage" */ './view/public/faq/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - faq';
       next();
      }
    },
    {
      path: '/cancer-classification/',
      name: 'cancerClassificationPage',
      component: () => import( /* webpackChunkName: "cancerClassificationPage" */ './view/public/mobile/cancer-classification-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - Cancer Classification Info';
       next();
      }
    },
    {
      path: '/ai-algoriths/',
      name: 'aiAlgorithmPage',
      component: () => import( /* webpackChunkName: "aiAlgorithmPage" */ './view/public/mobile/ai-algorithms-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - Ai Algorithms Info';
       next();
      }
    },
    {
      path: '/lbil/info/',
      name: 'LbilInfoPage',
      component: () => import( /* webpackChunkName: "LbilInfoPage" */ './view/public/mobile/LBIl-info-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - LBIL Info';
       next();
      }
    },
    {
      path: '/our/services/',
      name: 'ourServices',
      component: () => import( /* webpackChunkName: "ourServices" */ './view/public/services/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Our Services';
        next();
      }
    },
    {
      path: '/our/app/',
      name: 'ourApp',
      component: () => import( /* webpackChunkName: "ourApp" */ './view/public/our-app-page-info/index.vue'),
      guest: true,
      props:true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Our App';
        next();
      }
    },
    {
      path: '/all/event/list/',
      name: 'allEventList',
      component: () => import( /* webpackChunkName: "allEventList" */ './view/public/event/all-event-list/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Event Lists';
        next();
      }
    },
    {
      path: '/event/info/:evtId',
      name: 'eventInfo',
      component: () => import( /* webpackChunkName: "eventInfo" */ './view/public/event/event-info/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Event Info';
        next();
      }
    },
    {
      path: '/collaboration/info/',
      name: 'collaborationInfo',
      component: () => import( /* webpackChunkName: "collaborationInfo" */ './view/public/collaboration-project-info/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Project Collaboration Info';
        next();
      }
    },
    {
      path: '/public/vista/',
      name: 'publicVistaMedia',
      component: () => import( /* webpackChunkName: "publicVistaMedia" */ './view/public/vista-public-media-list/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('vistaPublicMediaListFun');
        document.title = 'Lymphomap - Media';
        next();
      }
    },
    {
      path: '/public/vista/detail/:videoID/',
      name: 'publicVistaMediaInfo',
      component: () => import( /* webpackChunkName: "publicVistaMediaInfo" */ './view/public/vista-public-media-details/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('vistaPublicMediaListFun');
        document.title = 'Lymphomap - Media';
        next();
      }
    },
  ]
})

// Routes use for without login. these are the name of routes not path
const openRoutes = ['HomeLandingMain', 'presentation', 'userAgreement', 'privacyPolicy', 'pubBlogDetail', 'trackingUnsubscribe', 'contactUs', 'AboutUsMainPage', 'loginMainPage', 'LbilInfoPage', 'aiAlgorithmPage', 'cancerClassificationPage', 'faqPage', 'ourServices', 'ourApp', 'allEventList', 'eventInfo', 'collaborationInfo', 'publicVistaMedia', 'publicVistaMediaInfo']

// Routes use for without login
router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    next();
  } else if (store.getters.isAuthenticated && localStorage.getItem('token') != '' && localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != '' && localStorage.getItem('LoginedUserID') != null) {
    next()
  } else {
    if (to.name != "blogDetail") {
      let redirectTo = to.path;
      let redirectToHash = to.hash;
      let redirectToFull = '?redirect=' + redirectTo + redirectToHash;
      next('/' + redirectToFull)
    } else {
      next('/public/blog/detail/' + to.params.blogId)
    }
  }
})

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
  if (to.name) {
    if (openRoutes.includes(to.name)) {
      $(".preloader").show()
    }
    next();
  }
});

/** Hide preloader after each routes */
router.afterEach((to, from) => {
  if (openRoutes.includes(to.name)) {
    $(".preloader").delay(200).fadeOut("slow");
  }
});

export default router;